// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"popOverMenuMultiLevel__gradient-bg5___tjAo","popOverMenu":"popOverMenuMultiLevel__popOverMenu__nd3q1","ellipsis":"popOverMenuMultiLevel__ellipsis__ArQzM"};